import { Component, OnInit, Inject } from '@angular/core';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { ClassNutrientDto, RawMaterialService, ReportDto } from '@sharedrest/data.restservice';
import { EntityServiceClient, MatrixDto, MatrixFilterDto } from '@sharedrest/equation.restservice';
import { UserService } from '@sharedcommon/services/user.service';
import { FormArrayValidators } from '@sharedcommon/util/form-array-validators.util';
import { saveAs } from 'file-saver';
import { CustomDataServiceClient } from '@sharedrest/data-custom.restservice';
import { HttpResponse } from '@angular/common/http';
import {NeqDialogService} from '@sharedcommon/services/dialog.service';
import {TranslateService} from '@ngx-translate/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  templateUrl: './report.dialog.html'
})
export class NeqReportDialogComponent implements OnInit {



  rawMaterialId: string;
  matrices: MatrixDto[];
  classes: ClassNutrientDto[];
  processing = false;

  public reportForm = new FormGroup({
    matrices: new FormArray([], [ FormArrayValidators.minNotNullChildren(1), FormArrayValidators.maxNotNullChildren(2) ]),
    classes: new FormArray([], [ FormArrayValidators.minNotNullChildren(1) ]),
    note: new FormControl(true)
  });

  constructor(
    private readonly userService: UserService,
    private readonly customDataServiceClient: CustomDataServiceClient,
    private readonly rawMatService: RawMaterialService,
    private readonly entityService: EntityServiceClient,
    private readonly dialogService: NeqDialogService,
    private readonly translateService: TranslateService,
    private readonly dialogRef: MatDialogRef<NeqReportDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {rawMaterialId: string}
  ) {
  }

  ngOnInit() {
    this.rawMaterialId = this.data.rawMaterialId;

    const mainMatrix = this.userService.getMainMatrix();

    this.entityService.matricesFetch(this.userService.getEntity(), new MatrixFilterDto()).subscribe(result => {
      this.matrices = result;
      const formArray = this.getMatrices();
      this.matrices.forEach(matrix => formArray.push(new FormControl(matrix.id === mainMatrix.id)));
    });

    this.rawMatService.getNutrientClasses(
      this.userService.getEntity(),
      this.rawMaterialId
    ).subscribe(classes => {
      this.classes = classes;
      const formArray = this.getClasses();
      this.classes.forEach(() => formArray.push(new FormControl(true)));
    });
  }

  process() {
    if (this.reportForm.invalid) {
      return;
    }
    this.processing = true;
    this.customDataServiceClient.entitiesRawMaterialsReportGetReport(this.userService.getEntity(), this.rawMaterialId, this.generateReportDto())
      .subscribe((data: HttpResponse<any>) => {
        try {
          let name = 'report.pdf';
          const content = data.headers.get('content-disposition');


          if (data?.headers) {
            if (content) {
              const match = /filename="?([^"]+)"?/.exec(content);
              if (match?.[1]) {
                name = match[1];
              }
            }

            let blob = new Blob([data.body], { type: 'application/pdf' });
            saveAs(blob, name);
          }

          this.dialogRef.close(true);

        } catch (e) {
          this.processing = false;
          this.dialogRef.close(true);
          this.dialogService.showErrorDetail(e, this.translateService.instant('error.user.rawmaterial.export.failed'));
        }
      }, err => {
        this.processing = false;
        this.dialogRef.close(true);
        this.dialogService.showErrorDetail(err, this.translateService.instant('error.user.rawmaterial.export.failed'));
      });
  }

  private generateReportDto(): ReportDto {
    const matrices = this.getMatrices().getRawValue();
    const classes = this.getClasses().getRawValue();

    const report = new ReportDto();
    report.matrices = this.matrices.filter((_m, i) => matrices[i]).map(m => m.code);
    report.classes = this.classes.filter((_m, i) => classes[i]).map(m => m.code);
    report.note = this.reportForm.get('note').value;

    return report;
  }

  private getMatrices(): FormArray {
    return this.reportForm.get('matrices') as FormArray;
  }

  private getClasses(): FormArray {
    return this.reportForm.get('classes') as FormArray;
  }

  cancel() {
    this.dialogRef.close(false);
  }
}
